import Vue from 'vue'
import App from './App.vue'
import store from './store'

import { i18n, resolveLanguage } from './lang/setup/i18n-setup'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

//............................................................
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
//............................................................
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
//............................................................
import './utils/filters.js'

import StratumUtils from './utils/stratum_utils'
Vue.use(StratumUtils);

import iconSets from './utils/icons'
Vue.use(iconSets)

//............................................................

import sharedActions from './utils/sharedActions'
Vue.use(sharedActions);

//............................................................

import VueMaterial from 'vue-material'
Vue.use(VueMaterial)

//............................................................

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import StratumNotify from './utils/stratum_notify'
Vue.use(StratumNotify);
//............................................................
import StratumValidation from './utils/stratum_validation'
Vue.use(StratumValidation);
//............................................................
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);
//............................................................
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

//............................................................
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import routes from './routes';

//.............................................................

// Vue.use(require('vue-moment'));

const router = new VueRouter({
  routes,
  mode: 'history',
  base: "/app/"
  //ENABLE BASE TO COMMIT

});

//.................................................................
import '../src/assets/scss/bulma.min.css'
import '../src/assets/scss/bulma.fixes.scss'
import '../src/assets/scss/summershoe.scss'
import '../src/assets/scss/sheet.scss'
import '../src/assets/scss/templatepages.scss'
import "sweetalert2/dist/sweetalert2.min.css";


// ..............................................................

let loadingGif = document.getElementById('load-message-index')
loadingGif.style.display = 'none';


//get the IP addresses associated with an account
// function getIPs(callback){
//   var ip_dups = {};

//   //compatibility for firefox and chrome
//   var RTCPeerConnection = window.RTCPeerConnection
//       || window.mozRTCPeerConnection
//       || window.webkitRTCPeerConnection;
//   var useWebKit = !!window.webkitRTCPeerConnection;

//   //bypass naive webrtc blocking using an iframe
//   if(!RTCPeerConnection){
//       //NOTE: you need to have an iframe in the page right above the script tag
//       //
//       //<iframe id="iframe" sandbox="allow-same-origin" style="display: none"></iframe>
//       //<script>...getIPs called in here...
//       //
//       var win = iframe.contentWindow;
//       RTCPeerConnection = win.RTCPeerConnection
//           || win.mozRTCPeerConnection
//           || win.webkitRTCPeerConnection;
//       useWebKit = !!win.webkitRTCPeerConnection;
//   }

//   //minimal requirements for data connection
//   var mediaConstraints = {
//       optional: [{RtpDataChannels: true}]
//   };

//   var servers = {iceServers: [{urls: "stun:stun.services.mozilla.com"}]};

//   //construct a new RTCPeerConnection
//   var pc = new RTCPeerConnection(servers, mediaConstraints);

//   function handleCandidate(candidate){
//       //match just the IP address
//       var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
//       var ip_addr = ip_regex.exec(candidate)[1];

//       //remove duplicates
//       if(ip_dups[ip_addr] === undefined)
//           callback(ip_addr);

//       ip_dups[ip_addr] = true;
//   }

//   //listen for candidate events
//   pc.onicecandidate = function(ice){

//       //skip non-candidate events
//       if(ice.candidate)
//           handleCandidate(ice.candidate.candidate);
//   };

//   //create a bogus data channel
//   pc.createDataChannel("");

//   //create an offer sdp
//   pc.createOffer(function(result){

//       //trigger the stun server request
//       pc.setLocalDescription(result, function(){}, function(){});

//   }, function(){});

//   //wait for a while to let everything done
//   setTimeout(function(){
//       //read candidate info from local description
//       var lines = pc.localDescription.sdp.split('\n');

//       lines.forEach(function(line){
//           if(line.indexOf('a=candidate:') === 0)
//               handleCandidate(line);
//       });
//   }, 1000);
// }

//Test: Print the IP addresses into the console
// getIPs(function(ip){
//   alert(ip);





//   function resolveRouterGuards(to, from, next) {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       if (!store.getters.authorized) {
//         if (!store.getters.authCookie) {
//           next({ name: "login", replace: true })
//         } else {
//           store.commit("setAuthorized", true)
//           next()
//         }
//       } else {
//         next()
//       }
//     } else {
//       if (store.getters.authCookie) {
//         next({ name: "home", replace: true })
//       }
//       next()
//     }
//   }
  
//   router.beforeEach((to, from, next) => {
//     resolveRouterGuards(to, from, next)
//   })
  
//   new Vue({
//     el: '#app',
//     router,
//     store,
//     i18n,
//     render: h => h(App),
//   })


// });
 

function resolveRouterGuards(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.authorized) {
      if (!store.getters.authCookie) {
        next({ name: "login", replace: true })
      } else {
        store.commit("setAuthorized", true)
        next()
      }
    } else {
      next()
    }
  } else {
    if (store.getters.authCookie) {
      next({ name: "home", replace: true })
    }
    next()
  }
}

router.beforeEach((to, from, next) => {
  resolveRouterGuards(to, from, next)
})

// new Vue({
//   el: '#app',
//   router,
//   store,
//   i18n,
//   render: h => h(App),
// })



if(isBlocked){
  getUserIP(function (ip) {
    console.log("ip: ", ip)
    ip = ip.split(".")
    ip = [ip[0], ip[1], ip[2]].join(".")
    if (ip && ip !== "172.16.16") {
      window.location.href = "https://bluetoken.io/maintenance/"
    } else {
  
      new Vue({
        el: '#app',
        router,
        store,
        i18n,
        render: h => h(App),
      })
  
    }
  })
  

  
}else{

  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
  })

}



function getUserIP(onNewIP) { //  onNewIp - your listener function for new IPs
  //compatibility for firefox and chrome
  var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
  var pc = new myPeerConnection({
    iceServers: []
  }),
    noop = function () { },
    localIPs = {},
    ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
    key;

  function iterateIP(ip) {
    if (!localIPs[ip]) onNewIP(ip);
    localIPs[ip] = true;
  }

  //create a bogus data channel
  pc.createDataChannel("");

  // create offer and set local description
  pc.createOffer(function (sdp) {
    sdp.sdp.split('\n').forEach(function (line) {
      if (line.indexOf('candidate') < 0) return;
      line.match(ipRegex).forEach(iterateIP);
    });

    pc.setLocalDescription(sdp, noop, noop);
  }, noop);

  //listen for candidate events
  pc.onicecandidate = function (ice) {
    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
  };
}




// WEBPACK FOOTER //
// ./src/main.js